import React, { useRef, useState } from "react";
import * as S from "./AccessibilityButton.style";
import { ReactComponent as AccessibilityIcon } from "../../../assets/images/icons/accessibility-button-icon.svg";
import useWindowSize from "../../../hooks/useWindowSize";
import { ModalResponsive } from "../Modal/Modal.Style";
import Button from "../../Habitacional/core/Button";

const AccessibilityButton = () => {
  const { width } = useWindowSize();
  const [isModalChatOpen, setIsModalChatOpen] = useState(false);
  const [regressiveCounter, setRegressiveCounter] = useState(10);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const isDesktop = width >= 768;
  const position = { x: isDesktop ? width - 85 : width - 50, y: 200 };
  const uri = "https://icom.app/CbNZG";

  const clearTimers = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleRegressiveCounter = () => {
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setRegressiveCounter((prev) => {
        if (prev <= 0) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleCloseModal = () => {
    setIsModalChatOpen(false);
    clearTimers();
    setRegressiveCounter(10);
  };

  const handleOpenAccessibilityChatWithButton = () => {
    window.open(uri, "_blank");
    handleCloseModal();
  };

  const handleOpenAccessibilityChat = () => {
    setIsModalChatOpen(true);
    setRegressiveCounter(10);
    handleRegressiveCounter();

    timeoutRef.current = setTimeout(() => {
      window.open(uri, "_blank");
      handleCloseModal();
    }, 10000);
  };

  return (
    <>
      <S.Button
        id="accessibility-button"
        onClick={handleOpenAccessibilityChat}
        position={position}
      >
        <AccessibilityIcon />
      </S.Button>
      <ModalResponsive show={isModalChatOpen} onClose={handleCloseModal}>
        <S.ContentAccessibilityButton>
          <S.TitleAccessibilityButton>
            Atendimento em LIBRAS
          </S.TitleAccessibilityButton>
          <S.DescriptionAccessibilityButton>
            Você será redirecionado para o site do ICOM, parceiro da Caixa
            Seguradora, para receber atendimento em LIBRAS.
          </S.DescriptionAccessibilityButton>
          <S.ContentCounterAccessibilityButton>
            <S.DescriptionAccessibilityButton>
              Você será redirecionado em
            </S.DescriptionAccessibilityButton>
            <S.CounterAccessibilityButton>
              {regressiveCounter}s
            </S.CounterAccessibilityButton>
          </S.ContentCounterAccessibilityButton>
        </S.ContentAccessibilityButton>

        <div className="divider" />

        <div className="footer">
          <Button
            style={{ borderRadius: "8px" }}
            variant={isDesktop ? "primary" : "tertiary"}
            type="button"
            onClick={handleOpenAccessibilityChatWithButton}
          >
            Prosseguir agora
          </Button>
        </div>
      </ModalResponsive>
    </>
  );
};

export default AccessibilityButton;
